/** Session pose overlay. Position changes only — never applyNodeChanges(painted). */

export function idKeyOf(nodes) {
  return (nodes || []).map((n) => n.id).join("\0");
}

function hasXY(p) {
  return p && Number.isFinite(p.x) && Number.isFinite(p.y);
}

/**
 * Commit layout pose. Mid-drag `dragging: true` updates are ignored so React
 * Flow's store owns the live transform (writing {0,0} or fighting each move
 * is what made nodes flash). Keyboard / drag-end have dragging !== true.
 */
export function foldPositionChanges(prev, changes) {
  let next = null;
  for (const c of changes || []) {
    if (c.type !== "position") continue;
    if (c.dragging === true) continue;
    if (!hasXY(c.position)) continue;
    next ??= new Map(prev);
    next.set(c.id, { x: c.position.x, y: c.position.y, dragging: false });
  }
  return next ?? prev;
}

export function applyPose(nodes, pose) {
  if (!pose || pose.size === 0) return nodes;
  return nodes.map((n) => {
    const p = pose.get(n.id);
    if (!p || !hasXY(p)) return n;
    return {
      ...n,
      position: { x: p.x, y: p.y },
    };
  });
}

export function paintNodes(builtNodes, selection, highlight, onEnter) {
  const sel = selection || [];
  const hi = highlight || [];
  return (builtNodes || []).map((n) => ({
    ...n,
    selected: sel.length ? sel.includes(n.id) : n.selected,
    data: {
      ...n.data,
      diag: hi.includes(n.id),
      onEnter: onEnter ? () => onEnter(n) : n.data?.onEnter,
    },
  }));
}

export function commitNodePose(prev, id, position) {
  if (!id || !hasXY(position)) return prev;
  const cur = prev.get(id);
  if (cur && cur.x === position.x && cur.y === position.y) return prev;
  const next = new Map(prev);
  next.set(id, { x: position.x, y: position.y, dragging: false });
  return next;
}
